import { render, staticRenderFns } from "./QianShou.vue?vue&type=template&id=4f06906e&scoped=true&"
import script from "./QianShou.vue?vue&type=script&lang=js&"
export * from "./QianShou.vue?vue&type=script&lang=js&"
import style0 from "./QianShou.vue?vue&type=style&index=0&id=4f06906e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06906e",
  null
  
)

export default component.exports